module.exports = __webpack_public_path__ + "img/lr-cb66-100.0545b9de.gif";